import { render } from "./System.templates.vue?vue&type=template&id=3d6d22f8&scoped=true"
import script from "./System.templates.vue?vue&type=script&lang=js"
export * from "./System.templates.vue?vue&type=script&lang=js"

import "./System.templates.vue?vue&type=style&index=0&id=3d6d22f8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6d22f8"]])

export default __exports__